import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/app.css';
import Home from './pages/Home';
import Confirmation from './pages/Confirmation';
import AdminLogin from './pages/AdminLogin';
import Admin from './pages/Admin';


import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import { ContentProvider } from './contexts/ContentContext';

function App() {
  return (
    <Router>
      <ContentProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/confirmation" element={<Confirmation />} />

          {/* Admin Routes */}
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />



        </Routes>
      </ContentProvider>
    </Router>
  );
}

export default App;
